<script setup lang="ts">
import { onMounted, ref } from 'vue';
import VueMultiselect from 'vue-multiselect';
import { FilterOption } from '@/application/smallBusiness/domain/SmallBusinessPlanFilters';

interface EmitInterface {
  (event: 'update-values', value: Array<FilterOption>): void
}

const emits = defineEmits<EmitInterface>();

const props = defineProps<{
  filterName: string;
  filters: Array<FilterOption>;
}>();

const selectedFilter = ref<Array<FilterOption>>([]);

const emitChanges = (): void => {
  const newFilters = props.filters.map(filter => {
    return { ...filter, value: selectedFilter.value.includes(filter) };
  });
  emits('update-values', newFilters);
};

onMounted(() => {
  selectedFilter.value = props.filters.filter(filter => filter.value === true);
});
</script>

<template>
  <VueMultiselect
    v-model="selectedFilter"
    :options="props.filters"
    label="text"
    :show-labels="false"
    :id="`${filterName}-selector`"
    track-by="key"
    :placeholder="`Select ${filterName}`"
    :allow-empty="true"
    multiple
    tab-index="0"
    @update:model-value="emitChanges"
  >
  </VueMultiselect>
</template>
